export default "__VITE_ASSET__CCP1rYJ4__"